import { GUI } from 'lil-gui';

export class TerrainGUI {
    constructor(terrainGenerator) {
        this.terrainGenerator = terrainGenerator;
        this.gui = new GUI();

        // 디바운스 타이머
        this.updateTimer = null;
        this.debounceDelay = 100;   // 100ms

        this.init();
    }

    init() {
        // GUI 제목
        this.gui.title('Terrain Controls');

        // GUI 바인딩용 파라미터
        this.params = {
            amplitude: this.terrainGenerator.amplitude,
            scale: this.terrainGenerator.scale,
            seed: this.terrainGenerator.seed,
            wireframe: false,
            regenerate: () => this.regenerate(),
            // FBM
            octaves: this.terrainGenerator.octaves,
            persistence: this.terrainGenerator.persistence,
            lacunarity: this.terrainGenerator.lacunarity,
            useFBM: this.terrainGenerator.useFBM
        };

        // 모든 컨트롤을 평평하게 나열
        this.setupControls();

        const fbmFolder = this.gui.addFolder('FBM Parameters');

        fbmFolder
            .add(this.params, 'useFBM')
            .name('Use FBM')
            .onChange((value) => {
                this.terrainGenerator.setUseFBM(value);
            });

        fbmFolder
            .add(this.params, 'octaves', 1, 8, 1)
            .name('Octaves')
            .onChange((value) => this.debouncedUpdate(() => {
                this.terrainGenerator.setOctaves(value);
            }));

        fbmFolder
            .add(this.params, 'persistence', 0, 1, 0.01)
            .name('Persistence')
            .onChange((value) => this.debouncedUpdate(() => {
                this.terrainGenerator.setPersistence(value);
            }));

        fbmFolder
            .add(this.params, 'lacunarity', 1, 4, 0.1)
            .name('Lacunarity')
            .onChange((value) => this.debouncedUpdate(() => {
                this.terrainGenerator.setLacunarity(value);
            }));
    }

    /**
     * 모든 GUI 컨트롤 설정
     */
    setupControls() {
        // 지형 파라미터
        this.gui
            .add(this.params, 'amplitude', 0, 20, 0.1)
            .name('Amplitude')
            .onChange((value) => this.debouncedUpdate(() => {
                this.terrainGenerator.setAmplitude(value);
            }));

        this.gui
            .add(this.params, 'scale', 0.01, 0.5, 0.01)
            .name('Scale')
            .onChange((value) => this.debouncedUpdate(() => {
                this.terrainGenerator.setScale(value);
            }));

        this.gui
            .add(this.params, 'seed')
            .name('Seed')
            .onFinishChange((value) => {
                this.terrainGenerator.setSeed(value);
            });

        // 시각 설정
        this.gui
            .add(this.params, 'wireframe')
            .name('Wireframe')
            .onChange((value) => {
                if (this.terrainGenerator.mesh) {
                    this.terrainGenerator.mesh.material.wireframe = value;
                }
            });

        // 액션
        this.gui
            .add(this.params, 'regenerate')
            .name('Regenerate Terrain');
    }

    /**
    * 디바운스된 업데이트
    * @param {Function} callback - 실행할 함수
    */
    debouncedUpdate(callback) {
        // 기존 타이머 취소
        if (this.updateTimer) {
            clearTimeout(this.updateTimer);
        }

        // 새 타이머 설정
        this.updateTimer = setTimeout(() => {
            callback();
            this.updateTimer = null;
        }, this.debounceDelay);
    }

    /**
     * 지형 재생성
     */
    regenerate() {
        this.terrainGenerator.update();
    }

    /**
     * GUI 제거
     */
    destroy() {
        this.gui.destroy();
    }
}